import styled, { css } from 'styled-components';

export const IndicatorWrapper = styled.div<{ $isRead: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 20px;
  right: ${(props) => props.theme.spacing['16px']};
  height: ${(props) => props.theme.spacing['16px']};
  width: ${(props) => props.theme.spacing['16px']};
  border-radius: 50%;
  ${({ $isRead }) =>
    $isRead
      ? css`
          background-color: rgba(47, 47, 47, 0.3);
        `
      : css`
          background-color: rgba(6, 147, 201, 0.3);
        `}
`;

export const Indicator = styled.div<{ $isRead: boolean }>`
  height: ${(props) => props.theme.spacing['8px']};
  width: ${(props) => props.theme.spacing['8px']};
  border-radius: 50%;
  ${({ $isRead }) =>
    $isRead
      ? css`
          background-color: ${({ theme }) => theme.colors.grey};
        `
      : css`
          background-color: ${({ theme }) => theme.colors.lightBlue};
        `}
`;
